export const encodeVaLaunchContext = ({ sta3n, duz }) => {
  const launchContext = {
    sta3n: String(sta3n || "").trim(),
    duz: String(duz || "").trim(),
  };

  return btoa(JSON.stringify(launchContext));
};

export const buildVaSiteLaunchUrl = ({ fhirServer, sta3n, duz, origin }) => {
  const resolvedFhirServer = String(fhirServer || "").trim();
  const resolvedOrigin =
    origin || (typeof window !== "undefined" ? window.location.origin : "");

  if (!resolvedFhirServer) {
    throw new Error("FHIR server is required to launch a point of care site.");
  }

  const url = new URL("/auth/fhir/callback", resolvedOrigin);
  url.searchParams.set("iss", resolvedFhirServer);
  url.searchParams.set("launch", encodeVaLaunchContext({ sta3n, duz }));
  return url.toString();
};
